import produce from "immer";

export function getNewItems({
  index,
  name1,
  name2,
  entities,
  undoneIds,
  newLocalId,
}) {
  let newItems;
  if (name1) {
    newItems = [
      { ...entities[undoneIds[index]] },
      blankChecklistItem(newLocalId, name2),
    ];
  } else if (name2) {
    newItems = [
      blankChecklistItem(newLocalId),
      { ...entities[undoneIds[index]], name: name2 },
    ];
  } else {
    newItems = [blankChecklistItem(newLocalId)];
  }
  const newIds = newItems.map((item) => item.id);
  const newEntities = makeEntities(newItems);
  return { newIds, newEntities };
}

export function createCommitReduce({ action, state }) {
  const { localId } = action.meta;
  const serverId = action.payload.id;
  const { entities } = state.openChecklist;
  let idsType = "undoneIds";
  let index = state.openChecklist[idsType].findIndex((id) => id === localId);
  if (index === -1) {
    idsType = "doneIds";
    index = state.openChecklist[idsType].findIndex((id) => id === localId);
  }
  if (index === -1) {
    console.warn(`${localId} not found in done or undone ids`);
    return state;
  }
  const oldItem = entities[localId];
  const newItem = { ...oldItem, id: serverId, isNew: false, isUnsaved: false };
  return produce(state, (draftState) => {
    draftState.openChecklist[idsType].splice(index, 1, serverId);
    draftState.openChecklist.entities[serverId] = newItem;
    console.log("entities, localId: ", entities, localId);
    delete draftState.openChecklist.entities[localId];
    delete draftState.pendingIds[localId];
  });
}

function blankChecklistItem(localId, name = "") {
  return { name: name, id: localId, isNew: true, isUnsaved: true };
}

function makeEntities(arr) {
  return arr.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});
}
